import { CommonModule } from '@angular/common';
import { Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { OktaAuthModule } from '@okta/okta-angular';
import { Divider } from 'primeng/divider';
import { Tooltip } from 'primeng/tooltip';
import { filter } from 'rxjs/operators';
import { environment as env } from 'src/environments/environment';
import { version as app_version } from 'src/environments/version';
import { BadgeComponent } from '../../shared/components/badge/badge.component';
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.css'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, Tooltip, Divider, BadgeComponent, OktaAuthModule],
})
export class ContentLayoutComponent implements OnInit {
  version = app_version;
  year = new Date().getFullYear();
  url = '';
  disableNavbarTooltip = true;
  hideChrome = false;
  public adminRole = env.adminRole;
  public opsRole = env.opsRole;
  private readonly destroyRef = inject(DestroyRef);
  ngOnInit(): void {
    this.sessionService.register();
  }

  constructor(
    private readonly router: Router,
    private readonly sessionService: SessionService,
  ) {
    // fetch current url to hide navbar from main page
    void this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      )
      .subscribe((e) => {
        this.url = e.url;
      });

    // listen to screen size to re-layout navbar
    this.checkScreenWidth();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.shiftKey && event.key === 'H') {
      event.preventDefault();
      this.hideChrome = !this.hideChrome;
    }
  }

  @HostListener('window:resize', ['$event'])
  checkScreenWidth() {
    const { innerWidth } = window;
    // console.log('innerWidth', innerWidth);
    // magic number found in .css file
    const widthBreakpoint = 1150;
    this.disableNavbarTooltip = innerWidth > widthBreakpoint;
  }
}
